import { format, isSameYear } from 'date-fns';

const RenderPeriodDateRange = ({ period }) => {
    if (!period || !period[0] || !period[1]) {
        return '';
    }

    const value1 = period[0];
    const value2 = period[1];

    if (isSameYear(value1, value2)) {
        return `${format(value1, 'd MMM')} - ${format(value2, 'd MMM y')}`;
    }

    return `${format(value1, 'd MMM y')} - ${format(value2, 'd MMM y')}`;
};

export default RenderPeriodDateRange;